import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';

const colors = appPalette.colors;

export const useStyles = makeStyles({
  root: {
    'align-items': 'center',
    display: 'flex',
    'flex-direction': 'row',
    marginBottom: '0.9375rem',
    position: 'relative',
    width: '100%',
    [theme.breakpoints.up('viewportMedium')]: {
      'margin-bottom': 0,
    },
  },
  stepNumber: {
    color: colors.black,
    display: 'block',
    'min-width': '1rem',
    transition: 'color .5s ease',
    marginRight: '0.5rem',
  },
  stepTitle: {
    'border-bottom': `0.0625rem solid ${colors.light_grey_1}`,
    color: colors.black,
    display: 'block',
    flex: 1,
    margin: '0',
    textAlign: 'unset',
    letterSpacing: '0',
    'transition-duration': '.5s',
    'transition-property': 'border, color',
    'transition-timing-function': 'ease',
  },
  stepDisabled: {
    color: colors.light_grey_2,
  },
  stepTitlePartial: {
    [theme.breakpoints.up('viewportMedium')]: {
      flex: 'none',
      'max-width': '26.875rem',
      width: '46.1%',
    },
  },
  stepCaption: {
    color: colors.acura_red,
    left: 0,
    position: 'absolute',
    top: '2.8125rem',
    transform: 'translateY(-50%)',

    [theme.breakpoints.up('viewportMobileMid')]: {
      left: 'auto',
      right: 0,
      top: '0.9375rem',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      top: '50%',
    },
  },
  stepContent: {
    [theme.breakpoints.up('viewportMedium')]: {
      'padding-left': '1.625rem',
    },
  },
});
